import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {servicePackagesService} from "../../services/servicePackages.service";

const initialState = {
    servicePackages: [],
    status: ''
}

const getAll = createAsyncThunk('servicePackagesSlice/getAll',
    async () => {
        try {
            const {data} = await servicePackagesService.getAll();

            return data.results;
        } catch (error) {
            throw error;
        }
    });

const servicePackagesSlice = createSlice({
    name: 'servicePackagesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => builder
        .addCase(getAll.fulfilled, (state, action) => {
            state.servicePackages = action.payload;

            state.status = 'success';
        })
        .addCase(getAll.pending, (state, action) => {
            state.status = 'loading';
        })
})

const {actions, reducer: servicePackagesReducer} = servicePackagesSlice;

const servicePackagesActions = {
    ...actions,
    getAll
}

export {
    servicePackagesActions,
    servicePackagesReducer,
}
